module.exports = __webpack_public_path__ + "static/img/about-qa.0f1e877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutImg/about-qa.png
// module id = n1u2
// module chunks = 3